import client from './payAPI';
import { PayAccount } from '../models/PayAccount';

export async function fetchPayAccount(): Promise<PayAccount> {
  const response = await client.get('front/v1/accounts/me');
  return response.data;
}
